<template>
  <BModal
    has-modal-card
    trap-focus
    active
    @close="closeModal"
  >
    <div class="customer-invoices">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Selecciona las facturas a relacionar
          </p>

          <BField label="Tipo de relación">
            <BSelect
              id="relation-type"
              v-model="relationType"
            >
              <option value="01">
                Nota de Crédito de los documentos relacionados
              </option>
              <option value="03">
                Devolución de mercancía sobre facturas o traslados previos
              </option>
            </BSelect>
          </BField>
          <AppPagination
            class="is-centered"
            :current-page="currentPage"
            :buttons-max="buttonsMax"
            :pages-total="totalPages"
            @change="goToPage"
          />
        </header>

        <section class="modal-card-body">
          <div class="table-container">
            <BTable
              :data="invoices"
              :checked-rows.sync="checkedRows"
              :columns="columns"
              :loading="loading"
              :custom-is-checked="
                (checkedRows, invoices) => { return checkedRows.id === invoices.id }"
              checkable
            >
              <template slot-scope="props">
                <BTableColumn
                  field="folio"
                  label="Folio"
                  internal
                >
                  {{ props.row.folio }}
                </BTableColumn>
                <BTableColumn
                  field="total"
                  label="Monto"
                  internal
                >
                  {{ props.row.cfdi.voucherTotal | toCurrency(props.row.cfdi.voucherCurrency) }}
                </BTableColumn>
                <BTableColumn
                  field="moneda"
                  label="Moneda"
                  internal
                >
                  {{ props.row.cfdi.voucherCurrency }}
                </BTableColumn>
                <BTableColumn
                  field="receiverName"
                  label="Receptor"
                  internal
                >
                  {{ props.row.cfdi.receiverName }}
                </BTableColumn>
                <BTableColumn
                  field="fecha"
                  label="Fecha"
                  internal
                >
                  {{ props.row.cfdi.voucherDate | toHumanDate }}
                </BTableColumn>
              </template>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <BIcon
                        icon="emoticon-sad"
                        size="is-large"
                      />
                    </p>
                    <p>No se encontraron facturas emitidas a este cliente</p>
                  </div>
                </section>
              </template>
            </BTable>
          </div>
        </section>

        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="closeModal"
          >
            Cerrar
          </button>
          <button
            class="button is-primary"
            type="button"
            @click="addInvoices"
          >
            Agregar facturas
          </button>
        </footer>
      </div>
    </div>
  </BModal>
</template>

<script>
import merge from 'lodash/merge';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'CustomerInvoices',
  components: {
    AppPagination: () => import(/* webpackChunkName: "app-pagination" */ '@/components/AppPagination.vue'),
  },
  props: {
    customer: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      buttonsMax: 5,
      loading: false,
      columns: [
        { field: 'folio', label: 'Folio' },
        { field: 'total', label: 'Monto' },
        { field: 'moneda', label: 'Moneda' },
        { field: 'receiverName', label: 'Receptor' },
        { field: 'fecha', label: 'Fecha' },
      ],
      checkedRows: [],
      relationType: '01',
    };
  },
  computed: merge(
    mapState({
      invoices: ({ invoices }) => invoices.list,
      totalPages: ({ invoices }) => invoices.totalPages,
      currentPageState: ({ invoices }) => invoices.currentPage,
    }),
    {
      lastPage() {
        return Math.ceil(this.invoices.length / this.itemsPerPage);
      },
      currentPage() {
        return parseInt(this.currentPageState, 10);
      },
      size() {
        return this.$route.query.size;
      },
    },
  ),
  async beforeMount() {
    this.loading = true;

    try {
      await this.searchInvoices({
        filters: { 'operation.customer': this.customer },
        isRep: false,
        page: 1,
        size: 20,
      });

      this.loading = false;
    } catch (error) {
      this.$danger({
        message: 'Ocurrió un error al obtener las facturas del cliente',
      });
    }
  },
  beforeDestroy() {
    this.setValue({ accessor: 'all', value: [] });
  },
  methods: merge(
    mapMutations({
      setValue: 'invoices/setValue',
      addConcepts: 'invoice/addConcepts',
      addCfdiRelated: 'invoice/addCfdiRelated',
    }),
    mapActions({
      searchInvoices: 'invoices/search',
    }),
    {
      async goToPage(page) {
        this.setValue({
          accessor: 'list',
          value: [],
        });
        this.setValue({
          accessor: 'currentPage',
          value: page,
        });
        try {
          await this.searchInvoices({
            filters: { 'operation.customer': this.customer },
            page,
            size: 20,
          });
        } catch (error) {
          this.$danger({ message: 'Ocurrió un error al buscar las facturas' });
        }
      },
      closeModal() {
        this.$router.push({ query: {} });
      },
      addInvoices() {
        this.checkedRows.forEach((invoice) => {
          this.addConcepts(invoice.cfdi.concepts);

          this.addCfdiRelated({
            type: this.relationType,
            uuid: invoice.uuid,
          });
        });

        this.$router.push({ query: {} });
      },
    },
  ),
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}

.modal-card {
  width: auto;
}

.modal-card-head {
  flex-direction: column;
}

.modal-card-title {
  padding-bottom: 1rem;
  font-weight: bold;
}
</style>
